<template>
  <fragment>
    <h2>Security</h2>
    <button
      type="button"
      class="btn btn-secondary full-width mt-4"
      @click="resetPassword"
    >
      <span>Change Password</span>
    </button>
  </fragment>
</template>

<script>
export default {
  name: 'SecurityBlock',

  methods: {
    resetPassword() {
      this.$globals.keycloak.login({
        action: 'UPDATE_PASSWORD'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 28px;
}
</style>
